import { c as _c } from "react/compiler-runtime";
import Icon from '../../../common/base/Icon';
import Text from '../../../common/base/Text';
const ConfirmDeleteDialog = t0 => {
  const $ = _c(5);
  const {
    text
  } = t0;
  let t1;
  if ($[0] !== text) {
    t1 = <Text>{text}</Text>;
    $[0] = text;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <Text danger={true} semi={true} m={{
      t: 2
    }}><Icon icon="error" left={1} /> This action cannot be undone!</Text>;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] !== t1) {
    t3 = <>{t1}{t2}</>;
    $[3] = t1;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  return t3;
};
export default ConfirmDeleteDialog;